import { FC } from 'react';
import { useQuery } from 'react-query';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import IResponseData from 'types/api';
import { useParams } from 'react-router';
import { ISelectOptionProps } from 'components/form/types';
import EditForm from './components/EditForm';
import { ICompany } from '../types';

const Screen: FC = () => {
  const { id } = useParams<{ id: string | undefined }>();

  const { isLoading, error, data } = useQuery<ICompany, Error>(
    ['client', { id }],
    (): Promise<ICompany> => API.get<IResponseData<ICompany>>(`clients?id=${id}`).then(res => res.data?.items[0])
  );

  const {
    isLoading: isLoadingTypes,
    error: errorTypes,
    data: typeOptions,
  } = useQuery<ISelectOptionProps[], Error>(
    ['companyTypeOptions'],
    (): Promise<ISelectOptionProps[]> => API.get<ISelectOptionProps[]>('clients/types').then(res => res.data)
  );

  const {
    isLoading: isLoadingLangOptions,
    error: errorLang,
    data: langOptions,
  } = useQuery<ISelectOptionProps[], Error>(
    ['companyDefaultLangOptions'],
    (): Promise<ISelectOptionProps[]> =>
      API.get<ISelectOptionProps[]>('clients/default-languages').then(res => res.data)
  );

  return (
    <MainLayout
      title="Редактиране на клиент"
      isLoading={isLoading && isLoadingTypes && isLoadingLangOptions}
      error={error || errorTypes}
    >
      {typeOptions && langOptions && data && (
        <EditForm
          client={data}
          typeOptions={typeOptions}
          langOptions={langOptions}
        />
      )}
    </MainLayout>
  );
};

export default Screen;
